import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

/**
 * Primary UI component for user interaction
 */
export const Button = ({ variant, backgroundColor, icon, size, formControl, className, to, ...props }) => {
  const navigate = useNavigate()
  return (
    <button
      type="button"
      className={[`btn btn-${variant}`, `btn-${size}`, `${formControl ? 'form-control' : ''}`].join(' ') + (className ? ` ${className}` : '')}
      style={backgroundColor && { backgroundColor }}
      {...props}
      {...to && { onClick: () => navigate(to) }}
    >
      {icon && <>{icon}</>}
      {props.children}
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline-primary']),
  size: PropTypes.oneOf(['sm', 'md']),
  icon: PropTypes.element,
  onClick: PropTypes.func,
  formControl: PropTypes.bool
};

Button.defaultProps = {
  backgroundColor: null,
  variant: 'primary',
  size: 'md',
  onClick: undefined,
  icon: null,
  formControl: false,
};